import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

// Active banners from admin. Same window logic as mobile CHome — status=active
// AND (start_date null or past) AND (end_date null or future). Priority ASC.
//
// Cached via TanStack Query — banners change rarely so 5-minute staleTime is
// safe and tab revisits render instantly.
export function useBanners() {
  const { data, isLoading } = useQuery({
    queryKey: ["banners"],
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const today = new Date().toISOString().split("T")[0];
      const { data, error } = await supabase
        .from("banners")
        .select("id, type, title, subtitle, cta, bg_color, priority, seller_id")
        .eq("status", "active")
        .or(`start_date.is.null,start_date.lte.${today}`)
        .or(`end_date.is.null,end_date.gte.${today}`)
        .order("priority", { ascending: true })
        .limit(10);
      if (error) throw error;
      return data || [];
    },
  });

  return { banners: data || [], loading: isLoading };
}
